import { Brand, Flex, Span } from "@ir/ui";
import { useAtomValue } from "jotai";
import { shareLinkDataAtom, shareLinkStatusAtom } from "@/store/shareLink";
import { ANALYTICS_CHECK_DATE_RANGE_LABEL } from "@/store/analytics";
import { DateService } from "@/core/services/Date.service";
import { DateAdapter } from "@/infrastructure/adapters/dayJs";
import { useAnalyticsMobile } from "@/hooks";

const dateService = new DateService(new DateAdapter());

const AnalyticsFilterReadOnly = () => {
  const isMobile = useAnalyticsMobile();
  const shareLink = useAtomValue(shareLinkDataAtom);
  const status = useAtomValue(shareLinkStatusAtom);
  const payload = shareLink?.resourcePayload;

  if (!payload) {
    return null;
  }

  const fromDate = dateService.format(payload.start_date, "MMM D, YYYY");
  const toDate = dateService.format(payload.end_date, "MMM D, YYYY");

  const purchaserLabel =
    payload.purchaser_labels && payload.purchaser_labels.length > 0
      ? payload.purchaser_labels.map(p => p.label).join(", ")
      : "All Purchasers";

  const showBrandHeader = status === "valid" && shareLink;

  return (
    <Flex wrap="no-wrap" align="center" justifyContent="space-between" className="analytics-filter-readonly w-100">
      {showBrandHeader && (
        <Flex
          align="center"
          gap={0.5}
          wrap="no-wrap"
          className="analytics-filter-readonly-brand me-2"
          style={{ width: 150 }}
        >
          <Brand
            boxShadow
            brandName={shareLink.brand.brandName}
            logoSrcCompact={shareLink.brand.brandLogoUrl ?? ""}
            variant="compact"
            size="small"
          />
          <Span className="text-md font-medium text-grey-800">{shareLink.brand.brandName}</Span>
        </Flex>
      )}
      <Flex wrap="wrap" gap={isMobile ? 0.25 : 1} align="center" justifyContent={isMobile ? "end" : "start"} className="flex-1">
        <Flex
          direction="row"
          className="analytics-filter-readonly-item"
          align="center"
          justifyContent={isMobile ? "end" : "start"}
          wrap="wrap"
          gap={0.5}
        >
          {!isMobile && (
            <Span className="analytics-filter-readonly-label text-sm text-grey-400">
              {ANALYTICS_CHECK_DATE_RANGE_LABEL}:
            </Span>
          )}

          <Span className="analytics-filter-readonly-value text-sm font-medium text-grey-700 text-right">
            {`${fromDate} - ${toDate}`}
          </Span>
        </Flex>
        <Flex
          direction="row"
          className={`analytics-filter-readonly-item ${isMobile ? "text-right" : "text-left"}`}
          align="center"
          justifyContent={isMobile ? "end" : "start"}
          wrap="wrap"
          gap={0.5}
        >
          {!isMobile && <Span className="analytics-filter-readonly-label text-sm text-grey-400">Purchaser:</Span>}
          <Span
            className="analytics-filter-readonly-value text-right analytics-filter-readonly-purchaser-value text-sm font-medium text-grey-700"
            title={purchaserLabel}
          >
            {purchaserLabel}
          </Span>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AnalyticsFilterReadOnly;
